var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0001 14.4C9.69748 14.4 11.3253 13.7257 12.5256 12.5255C13.7258 11.3253 14.4001 9.69739 14.4001 8.00001C14.4001 6.30262 13.7258 4.67476 12.5256 3.47452C11.3253 2.27429 9.69748 1.60001 8.0001 1.60001C6.30271 1.60001 4.67485 2.27429 3.47461 3.47452C2.27438 4.67476 1.6001 6.30262 1.6001 8.00001C1.6001 9.69739 2.27438 11.3253 3.47461 12.5255C4.67485 13.7257 6.30271 14.4 8.0001 14.4ZM8.8001 5.60001C8.8001 5.38783 8.71581 5.18435 8.56578 5.03432C8.41575 4.88429 8.21227 4.80001 8.0001 4.80001C7.78792 4.80001 7.58444 4.88429 7.43441 5.03432C7.28438 5.18435 7.2001 5.38783 7.2001 5.60001V7.20001H5.6001C5.38792 7.20001 5.18444 7.28429 5.03441 7.43432C4.88438 7.58435 4.8001 7.78783 4.8001 8.00001C4.8001 8.21218 4.88438 8.41566 5.03441 8.56569C5.18444 8.71572 5.38792 8.80001 5.6001 8.80001H7.2001V10.4C7.2001 10.6122 7.28438 10.8157 7.43441 10.9657C7.58444 11.1157 7.78792 11.2 8.0001 11.2C8.21227 11.2 8.41575 11.1157 8.56578 10.9657C8.71581 10.8157 8.8001 10.6122 8.8001 10.4V8.80001H10.4001C10.6123 8.80001 10.8158 8.71572 10.9658 8.56569C11.1158 8.41566 11.2001 8.21218 11.2001 8.00001C11.2001 7.78783 11.1158 7.58435 10.9658 7.43432C10.8158 7.28429 10.6123 7.20001 10.4001 7.20001H8.8001V5.60001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/PlusCircle.6d814c993cc0b9123c154932f94a18b9.svg";
export { ForwardRef as ReactComponent };